const parseRolePermission = (obj) => {
  const roles = [],
    permissions = [];
  for (let r of obj) {
    if (r.Role) {
      roles.push(r["Role"]["role_name"]);
      for (let p of r["Role"]["RolePermissions"]) {
        permissions.push(p["Permission"]["action"]);
      }
    }
  }
  return { roles, permissions };
};
const capitalize = (str) => {
  try {
    if (str) {
      let words = str.split(" ");
      words = words.map((w) => {
        return w.charAt(0).toUpperCase() + w.slice(1);
      });
      return words.join(" ");
    } else {
      return str;
    }
  } catch (error) {
    return "";
  }
};
export { parseRolePermission, capitalize };
